// extracted by mini-css-extract-plugin
module.exports = {"overflow":"index_overflow__wZA8F","dark_container":"index_dark_container__Skp5E"};